// extracted by mini-css-extract-plugin
export default {"Skills":"Skills_Skills__sroVj"};